import React, { useState } from 'react';
import { Box } from '@mui/material';

const DEFAULT_AGENT_AVATAR = '098c1ecf70d121464cad33f41b7ef899.avif';

// 本地 404 时的 fallback：DiceBear adventurer 彩色插画，带彩色背景
const DICEBEAR_API = 'https://api.dicebear.com/9.x/adventurer/svg';

/**
 * 笔记本 Agent 头像：优先加载 public/avatars/notebook-agents/ 中的本地文件
 * 本地 404 时用 DiceBear 彩色插画（需将头像文件放入 public/avatars/notebook-agents/ 并提交部署）
 * @param {string} agentAvatar - 头像文件名，如 xxx.avif
 * @param {string} notebookId - 笔记本 ID，fallback 时用于 seed
 * @param {number} size - 头像尺寸
 */
function NotebookAgentAvatar({ agentAvatar, notebookId, size = 40, sx = {} }) {
  const [useFallback, setUseFallback] = useState(false);
  const filename = agentAvatar || DEFAULT_AGENT_AVATAR;
  const localSrc = `/avatars/notebook-agents/${filename}`;
  const seed = agentAvatar || notebookId || 'notebook-agent';
  const fallbackSrc = `${DICEBEAR_API}?seed=${encodeURIComponent(seed)}&size=${size}&backgroundColor=b6e3f4,c0aede,ffd5dc,ffdfbf`;
  const src = useFallback ? fallbackSrc : localSrc;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        ...sx,
      }}
    >
      <img
        src={src}
        alt="笔记本 Agent"
        onError={() => setUseFallback(true)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </Box>
  );
}

export default NotebookAgentAvatar;
